import { createTheme, ThemeOptions } from '@mui/material'
import fonts from './_typography.module.scss'
import { colors } from './colors'
import createPalette from './palette'
import createTypography from './typography'
import createComponents from './components'
import { breakpoints, breakpoints_raw } from './breakpoints'
import createMixin from './mixins'

export const themeOption: ThemeOptions = {
  colors,
  fonts,
}

export const palette = createPalette(themeOption)
export const typography = createTypography(themeOption)
export const mixins = createMixin(breakpoints.breakpoints)
export const components = createComponents({
  ...themeOption,
  breakpoints: breakpoints.breakpoints,
  mixins,
  palette,
  typography,
})

export const themeBase = {
  palette,
  typography,
  components,
  colors,
  mixins,
}

const theme = () => {
  return createTheme({
    ...themeBase,
    breakpoints: breakpoints_raw,
  })
}

export default theme
